import { useAdminData } from "@providers/AdminDataProvider";

export const useMyAuth0Id = () => {
  const { loginProviderDetailsQuery } = useAdminData();
  const myId = loginProviderDetailsQuery.data?.getLoginProvider?.auth0User?.id;
  return myId;
};
